import React from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'
import * as styles from './index.module.css'
import { GradientBorder } from '../commons'

const Leadership = ({ title, subtitle, components }) => {
  return (
    <div className="wrapper">
      <div className={styles.container}>
        <h2 className={styles.title}>{title}</h2>
        <div className={styles.profiles}>
          {components.map((profile, idx) => (
            <div className={styles.profile} key={idx}>
              <GatsbyImage
                image={profile.image.gatsbyImageData}
                className={styles.headshot}
                alt={profile.image?.description || ''}
              />
              <h4 className={styles.designation}>
                {profile.subtitle.subtitle}
              </h4>
              <div className={styles.name}>{profile.title}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default Leadership
